@let $entity = entity();

<ng-template #extra>
  <ng-content select="[extra]"/>
</ng-template>

@if ($entity) {
  <div class="entity gapped tight">
    <div class="name app-row-auto gapped tight">
      @if ($entity.icon) {
        <icon [type]="$entity.icon"/>
      }

      @if (linked() || listControl?.linked()) {
        <a [routerLink]="route($entity)">{{ $entity.full_name || $entity.name }}</a>
      } @else {
        <span>{{ $entity.full_name || $entity.name }}</span>
      }
    </div>

    @if (isPromptOrPack($entity)) {
      <div class="description">
        {{ $entity.description }}
      </div>
      <div class="tags">
        <icon [type]="$entity.visibility" [title]="$entity.visibility | titlecase"/>
      </div>
      <div class="info app-row gapped tight text-secondary">
        <div>Version {{ $entity.version }}</div>
      </div>

      <div class="extra">
        <ng-container [ngTemplateOutlet]="extra"/>
      </div>
    } @else if (isUser($entity)) {
    }
  </div>
}
